import {TOGGLE_SIDEBAR} from './common.actions';

const initialState = {
    showSidebar: true,
    // [MODULE REDUCER] INITIAL STATE
};

const commonReducer = (state = initialState, action) => {
    switch (action.type) {
        case TOGGLE_SIDEBAR:
            return {...state, showSidebar: !state.showSidebar};
        // [MODULE REDUCER] SWITCH CASE
        default: return state;
    };
};

export default commonReducer;
